import * as React from 'react';

import isEmpty from 'lodash/isEmpty';
import { Label } from '@/components/shared/Label';
import { flattenUniqueValues } from './utils';

type Props = {
  errors?: any;
};

export const ErrorMessages: React.FC<Props> = ({ errors }) => {
  if (isEmpty(errors)) {
    return null;
  }
  return (
    <Label>
      {flattenUniqueValues(errors).map((message, i) => (
        <div key={i} className="error-list">
          {message}
        </div>
      ))}
    </Label>
  );
};
